import CameraViewState from '../states/CameraViewState';

import { Input }  from 'ohzi-core';
import { OS }  from 'ohzi-core';

import { Vector2 } from 'three';
import { Vector3 } from 'three';
import { Ray } from 'three';
import { Math as TMath } from 'three';

export default class CameraInitialState extends CameraViewState
{
  constructor(target_z, hall_size)
  {
    super();
    this.pan_speed = new Vector2();

    this.zoom_speed = 0;
    this.zoom_t = 0;

    this.tilt_degrees = 70;
    this.tilt_speed = 0;

    this.vector_down_axis = new Vector3(0, -1, 0);
    this.vector_up_axis   = new Vector3(0, 1, 0);
    this.vector_back_axis = new Vector3(0, 0, -1);
    this.vector_left_axis = new Vector3(-1, 0, 0);

    this.tmp_dir = new Vector3();
    this.tmp_ray = new Ray();

    this.tmp_intersection = new Vector3();
    this.tmp_mouse_dir = new Vector2();

    this.last_point = new Vector3();

    this.last_NDC = new Vector2();

    this.z = target_z;

    this.set_hall_size(hall_size);
  }

  on_enter(camera_controller)
  {
    this.t_damping = 0;
  }

  on_exit(camera_controller)
  {
  }

  set_hall_size(hall_size)
  {
    let offset = OS.is_mobile ? 10 : 20;
    this.hall_size = hall_size + offset;
  }

  update(camera_controller)
  {
    if (!camera_controller.input_enabled)
    {
      return;
    }

    // if (Input.left_mouse_button_down)
    // {
    let mouse_delta_dir = Input.NDC.clone().sub(this.last_NDC);

    // camera_controller.set_rotation_delta(mouse_delta_dir.x * 0.5, mouse_delta_dir.y * -0.5);
    // }

    // let prev_point    = CameraUtilities.get_plane_intersection(camera_controller.reference_position, undefined, this.last_point).clone();
    // let current_point = CameraUtilities.get_plane_intersection(camera_controller.reference_position, undefined, Input.NDC).clone();
    // current_point.sub(prev_point);

    // camera_controller.reference_position.x = Math.sin(Time.elapsed_time * 5);

    // if (Input.wheel_delta !== 0)
    // {
    // camera_controller.reference_position.x = this.fractal_brownian_motion(Time.elapsed_time, 0, 1, 0.001);
    // camera_controller.reference_position.y = this.fractal_brownian_motion(Time.elapsed_time * 0.3, 5, 1, 2) + 15;// (10, Time.elapsed_time + 50) * 0.5 + 15;
    // }

    if (Input.left_mouse_button_pressed)
    {
      this.last_NDC.copy(Input.NDC);
    }

    if (Input.left_mouse_button_down)
    {
      // let prev_point    = CameraUtilities.get_plane_intersection(camera_controller.reference_position, undefined, this.last_point).clone();
      // let current_point = CameraUtilities.get_plane_intersection(camera_controller.reference_position, undefined, Input.NDC).clone();
      // current_point.sub(prev_point);

      let mouse_delta_dir = Input.NDC.clone().sub(this.last_NDC);
      this.z -= mouse_delta_dir.y * 25;

      // camera_controller.reference_position.z -= mouse_delta_dir.y * 20;
    }

    // camera_controller.reference_position.z += Input.wheel_delta * 2;
    // camera_controller.reference_position.z += Time.delta_time;

    this.z += Input.wheel_delta * 2;
    // this.z += Time.delta_time;

    // this.last_point.copy(Input.NDC);

    this.z = TMath.clamp(this.z, -35, this.hall_size);
    camera_controller.reference_position.z += (this.z - camera_controller.reference_position.z) * 0.05;
    // camera_controller.reference_position.z = TMath.clamp(camera_controller.reference_position.z, -35, 200);

    this.last_NDC.copy(Input.NDC);
  }

  fractal_brownian_motion(elapsed_time, offset, amplitude = 1, frequency = 1)
  {
    let x = offset;
    let y = Math.sin(x * frequency);
    let t = 0.01 * (-elapsed_time * 2 * 130.0);

    y += Math.sin(x * frequency * 2.1 + t) * 4.5;
    y += Math.sin(x * frequency * 1.72 + t * 1.121) * 4.0;
    y += Math.sin(x * frequency * 2.221 + t * 0.437) * 5.0;
    y += Math.sin(x * frequency * 3.1122 + t * 4.269) * 2.5;
    y *= amplitude * 0.06;

    return y;
  }
}
